import React from 'react';
import axios from 'axios';
import { Form, Button } from 'reactstrap';
import Cookies from '../../../../util/cookies';
import colors from '../../../../common/colors';
import getConfig from 'next/config';

const config = getConfig().publicRuntimeConfig;

const formStyle = {
	textAlign: 'left',
	cursor: 'pointer',
};
const signoutStyle = {
	WebkitAppearance: 'none',
	boxShadow: 'none',
	background: 'transparent',
	border: 'none',
	padding: '0.5rem',
};

export default class SignoutButton extends React.Component {

	handleSignoutSubmit = (event) => {
		event.preventDefault();
		Cookies.delete(config.giveCookie);

		axios({
			method: 'post',
			url: `/auth/signout`,
			data: {
				_csrf: this.props._csrf,
			},
		}).then((response) => {
			window.location.href = '/';
		});

		if (window.eventDispatcher) {
			window.eventDispatcher.dispatchEventSync('logout', {}, {amplitude: true});
		}

		return false;
	};

	render() {
		const { session, color } = this.props;
		return (
			<Form className="signout-form" method="post" action="/auth/signout" onSubmit={this.handleSignoutSubmit} style={formStyle}>
				<Button type="submit" style={{ ...signoutStyle, color: '#00000080' }}>Sign out</Button>
			</Form>
		);
	}
}
